import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { API_GATEWAY_URL } from '../../config/constants';
import UserHelper from '../../common/utils/userHelper';
import { getImage } from '../../utils/helper';
import { getExhibitorsByEventId } from '../../api/exhibitorsApi';
import { highlightTitle } from '../../utils/htmlHelper';
import "../../assets/styles/exhibitor.css";

interface AboutProps {
    landingPageData: any; 
    label: string;
}

const Exhibitors: React.FC<AboutProps> = ({ landingPageData,label }) => {
  
  const eventId = UserHelper.getEventId();
  const [data, setData] = useState<any[]>([]); 
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const eventData = useSelector((state: any) => state.eventData, shallowEqual);
   
  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        let response = await getExhibitorsByEventId(eventId);
        console.log('Exhibition page data:', response);
        setData(response);
      } catch (error) {
        console.error('Error fetching gallery page data:', error);
      }
    };

    fetchGalleryData();
  }, [eventId]);

  const text = landingPageData?.event_exhibitors_text || '';
  const eventTitle = eventData?.title || '';
 const settings = {
    // dots: true,
    infinite: data.length > 1,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,           // 👈 Enable auto sliding
    autoplaySpeed: 2000,      // 👈 3 seconds interval
    arrows: false,
  };
  if (!Array.isArray(data) || data.length === 0) {
    return null;
  }

  return (
     <div className="single-section gallery-area" id="exhbitors">
          <div className="container">
            <div className="section-heading">
              <h2 className="section-title" style={{
   '--before-bg': eventData.primary_color
  }}>{label}</h2>
              <p className="section-description col-lg-12 col-md-10 col-sm-12">
                {highlightTitle(text, eventTitle)}
              </p>
            </div>
    
            <Slider {...settings}>
              {data?.length > 0 ? (
                data.map((src:any, index:any) => (
                  <div key={index} className="img-slide text-center">
                    <img
                      src={getImage(src.logo)}
                      alt={`Booth ${index + 1}`}
                      style={{ width: '350px', height: '300px', borderRadius: '12px' }}
                    />
                     <strong>{UserHelper.getEventTitleByName(src.translations)}</strong>
                  </div>

                ))
              ) : (
                <p>No Exhibitor to display</p>
              )}
            </Slider>
          </div>
        </div>
  );
};

export default Exhibitors;